import { createFileRoute } from "@tanstack/react-router";
import { UserDetailPage } from "../../../components/users/UserDetailPage";

export const Route = createFileRoute("/workspace/users/$userId/")({
  component: UserDetailRoute,
});

function UserDetailRoute() {
  const { userId } = Route.useParams();
  return <UserDetailPage userId={userId} />;
}
